export default __webpack_public_path__ + "static/media/next-elevateswarovski.5d279f3f.jpg";